<template>
    <div>       
        <br/>There are 5 types of Gear:
        <ul>
            <li><a @click="scrollTo('ammunition')" >Ammunition</a></li>
            <li><a @click="scrollTo('grenade')">Grenade</a></li>
            <li><a @click="scrollTo('blanch')">Blanch</a></li>
            <li><a @click="scrollTo('utility')">Utility</a></li>
            <li><a @click="scrollTo('implement')">Implement</a></li>
        </ul>
        <br/><br/>
        
        <div v-for="type in gearTypes" :key="type">
            <h2 :id="type" style="color:cornflowerblue">{{filterString(type)}}:</h2>            
            <table style="width:100%">
                <tr>
                    <th>Name</th>
                    <th>Rarity</th>
                    <th>Stack</th>
                    <th>Description</th>
                </tr>
                <tr v-for="gear in sortedGear(type)" :key="gear.name"> 
                    <td style="padding-left:4px">{{gear.name}}</td>
                    <td style="text-align:center">{{gear.rarity}}</td>
                    <td style="text-align:center">{{gear.stack}}</td>
                    <td style="padding-left:4px">{{gear.longDesc}}</td>
                </tr>
            </table>  
            <br/>
        </div>
    </div>
</template>
<script>
//
import {gear} from "../../../play/data"
import {gearTypes} from "../../../play/constants"

export default {
  components: {
  },
  props:{
  },
  mounted(){
  },
  data(){
      return{
          gearTypes,
      }
  },
  methods:{
      sortedGear(type){
        let allGear = [...gear]
        let sortedGear = allGear.filter(gear=>gear.type == type )        
        //let sorted = sortedPotions.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0))
        return sortedGear
      },
      scrollTo(id){
        let section = document.getElementById(id)
        section.scrollIntoView({behavior: "smooth"})
      },    
      filterString(str){
         // let remove = str.replace("Handed"," Handed")
          let newStr = str[0].toUpperCase() + str.substring(1)
          return newStr

      },
  }

}
</script>
<style scoped>
table, th, td {
  border:1px solid black;
}
</style>